import moment from 'moment'

import { DateInput } from './DateInput'

export function isValidDate(date:DateInput, startYear?:number, endYear?:number) {
  date = moment(date);
  return date && date.isValid() && (startYear === undefined || date.get('year') >= startYear) && (endYear === undefined || date.get('year') <= endYear);
}
